import { ethers } from 'ethers';
import { CPGABI } from '../ABI/ABI';

const DIRECT_REQUEST_EVENTS = ['PaymentRequested', 'PaymentRequestCreated'];
const MILESTONE_REQUEST_EVENTS = [
    'LockedPaymentRequested',
    'LockedPaymentRequestCreated',
];

/**
 * Reads requestId from payment-request creation event logs.
 */
export function extractPaymentRequestIdFromReceipt(receipt, kind = 'direct') {
    const eventNames =
        kind === 'milestone' ? MILESTONE_REQUEST_EVENTS : DIRECT_REQUEST_EVENTS;
    if (!receipt?.logs?.length) return null;
    const iface = new ethers.Interface(CPGABI);
    for (const log of receipt.logs) {
        try {
            const parsed = iface.parseLog({
                topics: [...log.topics],
                data: log.data,
            });
            if (parsed && eventNames.includes(parsed.name)) {
                const id = parsed.args?.requestId;
                if (id === undefined || id === null) return null;
                return Number(id);
            }
        } catch (_e) {
            continue;
        }
    }
    return null;
}

const RESOLVED_REQUEST_EVENTS = [
    'PaymentRequestResolved',
    'LockedPaymentRequestResolved',
];

const REQUEST_STATUS_ACCEPTED = 1;
const REQUEST_STATUS_REJECTED = 2;

/**
 * Reads resolution details from accept/reject transaction receipt.
 */
export function extractRequestResolutionFromReceipt(receipt) {
    if (!receipt?.logs?.length) return null;
    const iface = new ethers.Interface(CPGABI);
    for (const log of receipt.logs) {
        try {
            const parsed = iface.parseLog({
                topics: [...log.topics],
                data: log.data,
            });
            if (!parsed || !RESOLVED_REQUEST_EVENTS.includes(parsed.name)) {
                continue;
            }
            const requestId = parsed.args?.requestId;
            const statusCode = Number(parsed.args?.status);
            const linkedPaymentId = parsed.args?.linkedPaymentId;
            if (requestId === undefined || requestId === null) return null;

            let status = 'pending';
            if (statusCode === REQUEST_STATUS_ACCEPTED) status = 'accepted';
            if (statusCode === REQUEST_STATUS_REJECTED) status = 'rejected';

            return {
                requestId: Number(requestId),
                status,
                linkedPaymentId:
                    linkedPaymentId != null && Number(linkedPaymentId) > 0
                        ? Number(linkedPaymentId)
                        : null,
            };
        } catch (_e) {
            continue;
        }
    }
    return null;
}
